var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"FormattedDate"},[(!this.date || !this.dateFormat)?_c('loader',{attrs:{"width":"14","height":"14"}}):_c('time',{attrs:{"datetime":"date"},domProps:{"textContent":_vm._s(_vm.formattedDate)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }